import { orderDetailsButtonSetStyles as styles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsButtonSet";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

styles.shareEntityButtonStyles = {
    ...styles.shareEntityButtonStyles,
    button: {
        ...styles.shareEntityButtonStyles?.button,
        variant: "secondary",
        css: css`
            border-color: ${getColor("primary.main")};
            color: ${getColor("primary.main")};
        `,
    },
};

styles.cancelButton = {
    ...styles.cancelButton,
    variant: "secondary",
};

styles.printButton = {
    ...styles.printButton,
    variant: "secondary",
};

styles.rmaButton = {
    ...styles.rmaButton,
    variant: "primary",
    css: css`
        ${styles.rmaButton?.css}
        span {
            line-height: 1;
        }
    `,
};

styles.reorderButton = {
    ...styles.reorderButton,
    variant: "secondary",
};
